(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5052],{

/***/ 35052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ Auth; },
  "J": function() { return /* binding */ AuthGuardPopup; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./app/components/ui/button.component.tsx
var button_component = __webpack_require__(61947);
// EXTERNAL MODULE: ./app/components/ui/divider.module.scss
var divider_module = __webpack_require__(48335);
var divider_module_default = /*#__PURE__*/__webpack_require__.n(divider_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/ui/divider.component.tsx


var Divider = function Divider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (divider_module_default()).divider,
    children: children
  });
};
// EXTERNAL MODULE: ./app/components/auth/auth.module.scss
var auth_module = __webpack_require__(47754);
var auth_module_default = /*#__PURE__*/__webpack_require__.n(auth_module);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(69273);
// EXTERNAL MODULE: ./app/components/ui/input.component.tsx
var input_component = __webpack_require__(50147);
// EXTERNAL MODULE: ./app/components/auth/reset-password.module.scss
var reset_password_module = __webpack_require__(85790);
var reset_password_module_default = /*#__PURE__*/__webpack_require__.n(reset_password_module);
// EXTERNAL MODULE: ./app/context/auth.context.tsx
var auth_context = __webpack_require__(92862);
// EXTERNAL MODULE: ./app/components/icons/Loader.tsx
var Loader = __webpack_require__(37387);
// EXTERNAL MODULE: ./app/hooks/go-back.hook.ts
var go_back_hook = __webpack_require__(71014);
// EXTERNAL MODULE: ./app/hooks/lang.ts + 22 modules
var lang = __webpack_require__(91289);
// EXTERNAL MODULE: ./app/components/back-button/back-button.component.tsx
var back_button_component = __webpack_require__(56227);
// EXTERNAL MODULE: ./app/context/virtual-keyboard.context.tsx
var virtual_keyboard_context = __webpack_require__(5451);
;// CONCATENATED MODULE: ./app/components/auth/reset-password.component.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var ResetPassword = function ResetPassword(_ref) {
  var _errors$email;

  var onClose = _ref.onClose,
      onGoToLogin = _ref.onGoToLogin;

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      setError = _useForm.setError,
      errors = _useForm.formState.errors;

  var _useAuth = (0,auth_context/* useAuth */.a)(),
      resetPassword = _useAuth.resetPassword;

  var _useState = (0,react.useState)(""),
      targetEmail = _useState[0],
      setTargetEmail = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var t = (0,lang/* useTranslate */.q)();

  var _useVirtualKeyboardCo = (0,virtual_keyboard_context/* useVirtualKeyboardContext */.z)(),
      activeInput = _useVirtualKeyboardCo.activeInput;

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(value) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setIsLoading(true);
              _context.next = 4;
              return resetPassword(value.email);

            case 4:
              onSuccess(value.email);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              setError("email", {
                type: "manual",
                message: t("auth.reset-password-error")
              });

            case 10:
              setIsLoading(false);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onSuccess = function onSuccess(email) {
    setTargetEmail(email);
  };

  var goBackCallback = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("ResetPassword", goBackCallback, !activeInput);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(back_button_component/* BackButtonBar */.K, {
      onClick: onClose
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (reset_password_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: t("auth.reset-password")
      }), !isLoading || errors !== null && errors !== void 0 && errors.email ? !targetEmail && /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (reset_password_module_default()).form_group,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "data-navigate-row": true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(input_component/* Input */.I, _objectSpread(_objectSpread({}, register("email", {
              required: t("field-required")
            })), {}, {
              placeholder: "Email",
              error: errors === null || errors === void 0 ? void 0 : (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message,
              "data-navigate-item": true,
              onFocus: function onFocus(e) {
                setTimeout(function () {
                  e.target.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                  });
                }, 100);
              }
            }))
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-navigate-row": true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* Button */.zx, {
            "data-navigate-item": true,
            children: t("send")
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (reset_password_module_default()).loader_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {})
      }), targetEmail && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (reset_password_module_default()).success_info,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: t("auth.reset-password-success", {
            email: targetEmail
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-navigate-row": true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* Button */.zx, {
            "data-navigate-item": true,
            onClick: onGoToLogin,
            children: t("log-in")
          })
        })]
      })]
    })]
  });
};
// EXTERNAL MODULE: ./app/components/auth/sign-in.module.scss
var sign_in_module = __webpack_require__(40745);
var sign_in_module_default = /*#__PURE__*/__webpack_require__.n(sign_in_module);
// EXTERNAL MODULE: ./app/context/features.context.tsx
var features_context = __webpack_require__(10833);
;// CONCATENATED MODULE: ./app/components/auth/sign-in.component.tsx



function sign_in_component_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function sign_in_component_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? sign_in_component_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : sign_in_component_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var SignIn = function SignIn(_ref) {
  var _errors$email, _errors$email2, _errors$password, _errors$password2;

  var onClose = _ref.onClose,
      _ref$onSuccess = _ref.onSuccess,
      onSuccess = _ref$onSuccess === void 0 ? function () {} : _ref$onSuccess,
      _ref$onForgotPassword = _ref.onForgotPassword,
      onForgotPassword = _ref$onForgotPassword === void 0 ? function () {} : _ref$onForgotPassword;
  var t = (0,lang/* useTranslate */.q)();

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      setError = _useForm.setError,
      errors = _useForm.formState.errors;

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      facebookLoginEnabled = _useFeaturesContext.facebookLoginEnabled;

  var _useVirtualKeyboardCo = (0,virtual_keyboard_context/* useVirtualKeyboardContext */.z)(),
      activeInput = _useVirtualKeyboardCo.activeInput;

  var _useAuth = (0,auth_context/* useAuth */.a)(),
      signInUser = _useAuth.signInUser,
      redirectToFacebookLogin = _useAuth.redirectToFacebookLogin;

  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(value) {
      var _session;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setIsLoading(true);
              _context.next = 4;
              return signInUser(value.email, value.password);

            case 4:
              _session = _context.sent;
              onSuccess(_session);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              setError("email", {
                type: "manual",
                message: t("could-not-sign-in-please-check-your-email-and-password")
              });

            case 11:
              setIsLoading(false);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var goBackCallback = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("SignIn", goBackCallback, !activeInput);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (sign_in_module_default()).back_container,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(back_button_component/* BackButtonBar */.K, {
        onClick: onClose
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (sign_in_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: t("log-in")
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (sign_in_module_default()).form_group,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "data-navigate-row": true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(input_component/* Input */.I, sign_in_component_objectSpread(sign_in_component_objectSpread({}, register("email", {
              required: true
            })), {}, {
              "data-navigate-item": true,
              placeholder: t("email"),
              disabled: isLoading,
              error: (errors === null || errors === void 0 ? void 0 : (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.type) === "required" ? t("email-is-required") : errors === null || errors === void 0 ? void 0 : (_errors$email2 = errors.email) === null || _errors$email2 === void 0 ? void 0 : _errors$email2.message,
              onFocus: function onFocus(e) {
                setTimeout(function () {
                  e.target.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                  });
                }, 100);
              }
            }))
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "data-navigate-row": true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(input_component/* Input */.I, sign_in_component_objectSpread(sign_in_component_objectSpread({}, register("password", {
              required: true
            })), {}, {
              type: "password",
              "data-navigate-item": true,
              placeholder: t("password"),
              disabled: isLoading,
              error: (errors === null || errors === void 0 ? void 0 : (_errors$password = errors.password) === null || _errors$password === void 0 ? void 0 : _errors$password.type) === "required" ? t("password-is-required") : errors === null || errors === void 0 ? void 0 : (_errors$password2 = errors.password) === null || _errors$password2 === void 0 ? void 0 : _errors$password2.message,
              onFocus: function onFocus(e) {
                setTimeout(function () {
                  e.target.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                  });
                }, 100);
              }
            }))
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-navigate-row": true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* Button */.zx, {
            loading: isLoading,
            "data-navigate-item": true,
            type: "submit",
            disabled: isLoading,
            children: t("log-in")
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        "data-navigate-row": true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* ButtonText */.oD, {
          "data-navigate-item": true,
          className: (sign_in_module_default()).forgot_button,
          onClick: onForgotPassword,
          children: t("forgot-password")
        })
      }), facebookLoginEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (sign_in_module_default()).facebook_btn_wrapper,
        "data-navigate-row": true,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(button_component/* Button */.zx, {
          className: (sign_in_module_default()).facebook_btn,
          "data-navigate-item": true,
          type: "button",
          onClick: function onClick() {
            return redirectToFacebookLogin();
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/facebook-white.png",
            alt: "facebook"
          }), t("log-in-with-facebook")]
        })
      })]
    })]
  });
};
// EXTERNAL MODULE: ./app/components/auth/sign-up.module.scss
var sign_up_module = __webpack_require__(7383);
var sign_up_module_default = /*#__PURE__*/__webpack_require__.n(sign_up_module);
// EXTERNAL MODULE: ./services-hooks/config.ts + 5 modules
var config = __webpack_require__(48788);
;// CONCATENATED MODULE: ./app/components/auth/sing-up.component.tsx



function sing_up_component_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function sing_up_component_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? sing_up_component_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : sing_up_component_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var SignUp = function SignUp(_ref) {
  var _errors$email, _errors$email2, _errors$password, _errors$password2, _errors$password3, _errors$password4;

  var onClose = _ref.onClose,
      onSuccess = _ref.onSuccess;
  var t = (0,lang/* useTranslate */.q)();

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      setError = _useForm.setError,
      errors = _useForm.formState.errors;

  var _useAuth = (0,auth_context/* useAuth */.a)(),
      signUp = _useAuth.signUp,
      signInUser = _useAuth.signInUser,
      redirectToFacebookLogin = _useAuth.redirectToFacebookLogin;

  var _useVirtualKeyboardCo = (0,virtual_keyboard_context/* useVirtualKeyboardContext */.z)(),
      activeInput = _useVirtualKeyboardCo.activeInput;

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      facebookLoginEnabled = _useFeaturesContext.facebookLoginEnabled;

  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(value) {
      var _session, _e$response, _e$response2, _e$response3;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.prev = 1;
              _context.next = 4;
              return signUp(value.email, value.password);

            case 4:
              _context.next = 6;
              return signInUser(value.email, value.password);

            case 6:
              _session = _context.sent;

              if (onSuccess) {
                onSuccess(_session);
              }

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);

              if (_context.t0 instanceof config/* RequestError */.L) {
                if ((_e$response = _context.t0.response) !== null && _e$response !== void 0 && _e$response.data.errors && (_e$response2 = _context.t0.response) !== null && _e$response2 !== void 0 && _e$response2.data.errors.length) {
                  (_e$response3 = _context.t0.response) === null || _e$response3 === void 0 ? void 0 : _e$response3.data.errors.forEach(function (error) {
                    if (error.field) {
                      setError(error.field, {
                        type: "manual",
                        message: error.field_message
                      });
                    } else if (error.code === "user_exists") {
                      setError("email", {
                        type: "manual",
                        message: t("auth.email-exists-error")
                      });
                    } else {
                      setError("email", {
                        type: "manual",
                        message: error.message
                      });
                    }
                  });
                }
              }

            case 13:
              setIsLoading(false);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var goBackCallback = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("SignUp", goBackCallback, !activeInput);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(back_button_component/* BackButtonBar */.K, {
      onClick: onClose
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (sign_up_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: t("sign-up")
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (sign_up_module_default()).form_group,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "data-navigate-row": true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(input_component/* Input */.I, sing_up_component_objectSpread(sing_up_component_objectSpread({}, register("email", {
              required: true
            })), {}, {
              placeholder: t("email"),
              error: ((_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.type) === "required" ? t("email-is-required") : (_errors$email2 = errors.email) === null || _errors$email2 === void 0 ? void 0 : _errors$email2.message,
              "data-navigate-item": true,
              disabled: isLoading,
              onFocus: function onFocus(e) {
                setTimeout(function () {
                  e.target.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                  });
                }, 100);
              }
            }))
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "data-navigate-row": true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(input_component/* Input */.I, sing_up_component_objectSpread(sing_up_component_objectSpread({}, register("password", {
              required: true,
              minLength: 8,
              maxLength: 30
            })), {}, {
              type: "password",
              placeholder: t("password"),
              error: ((_errors$password = errors.password) === null || _errors$password === void 0 ? void 0 : _errors$password.type) === "required" ? t("password-is-required") : ((_errors$password2 = errors.password) === null || _errors$password2 === void 0 ? void 0 : _errors$password2.type) === "minLength" || ((_errors$password3 = errors.password) === null || _errors$password3 === void 0 ? void 0 : _errors$password3.type) === "maxLength" ? t("auth.password-length-validation") : (_errors$password4 = errors.password) === null || _errors$password4 === void 0 ? void 0 : _errors$password4.message,
              "data-navigate-item": true,
              disabled: isLoading,
              onFocus: function onFocus(e) {
                setTimeout(function () {
                  e.target.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                  });
                }, 100);
              }
            }))
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-navigate-row": true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* Button */.zx, {
            disabled: isLoading,
            loading: isLoading,
            "data-navigate-item": true,
            type: "submit",
            children: t("create-an-account")
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (sign_up_module_default()).accept_terms,
          children: t("accept-terms")
        }), facebookLoginEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (sign_up_module_default()).facebook_btn_wrapper,
          "data-navigate-row": true,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(button_component/* Button */.zx, {
            className: (sign_up_module_default()).facebook_btn,
            "data-navigate-item": true,
            type: "button",
            onClick: function onClick() {
              return redirectToFacebookLogin();
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/facebook-white.png",
              alt: "facebook"
            }), t("log-in-with-facebook")]
          })
        })]
      })]
    })]
  });
};
// EXTERNAL MODULE: ./app/components/auth/sign-in-mobile.module.scss
var sign_in_mobile_module = __webpack_require__(33815);
var sign_in_mobile_module_default = /*#__PURE__*/__webpack_require__.n(sign_in_mobile_module);
// EXTERNAL MODULE: ./services-hooks/hooks.ts + 1 modules
var hooks = __webpack_require__(90413);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useInterval.js
var useInterval = __webpack_require__(43337);
// EXTERNAL MODULE: ./app/store/slices/user.ts
var user = __webpack_require__(38886);
// EXTERNAL MODULE: ./app/store/store.ts
var store = __webpack_require__(4062);
;// CONCATENATED MODULE: ./app/components/auth/sign-in-mobile.component.tsx













var SignInMobile = function SignInMobile(_ref) {
  var _data$data, _data$data$data, _data$data2, _data$data2$data, _data$data6, _data$data6$data, _data$data6$data$sess, _data$data6$data$sess2;

  var onClose = _ref.onClose,
      _ref$onSuccess = _ref.onSuccess,
      onSuccess = _ref$onSuccess === void 0 ? function () {} : _ref$onSuccess;
  var t = (0,lang/* useTranslate */.q)();
  var dispatch = (0,store/* useAppDispatch */.TL)();

  var _useVirtualKeyboardCo = (0,virtual_keyboard_context/* useVirtualKeyboardContext */.z)(),
      activeInput = _useVirtualKeyboardCo.activeInput;

  var _useGetPillowSessionV = (0,hooks/* useGetPillowSessionV2Login_code */.GZ)(),
      data = _useGetPillowSessionV.data,
      refetch = _useGetPillowSessionV.refetch,
      remove = _useGetPillowSessionV.remove;

  var interval = (data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : (_data$data$data = _data$data.data) === null || _data$data$data === void 0 ? void 0 : _data$data$data.interval) || 10;
  var code = (data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : (_data$data2$data = _data$data2.data) === null || _data$data2$data === void 0 ? void 0 : _data$data2$data.key) || "";
  (0,useInterval/* default */.Z)(function () {
    if (code) {
      refetch();
    }
  }, interval * 1000);
  (0,react.useEffect)(function () {
    var _data$data3, _data$data3$data, _data$data3$data$sess;

    if (data !== null && data !== void 0 && (_data$data3 = data.data) !== null && _data$data3 !== void 0 && (_data$data3$data = _data$data3.data) !== null && _data$data3$data !== void 0 && (_data$data3$data$sess = _data$data3$data.session) !== null && _data$data3$data$sess !== void 0 && _data$data3$data$sess.user) {
      var _data$data4, _data$data4$data, _data$data5, _data$data5$data;

      dispatch(user/* userActions.setSession */.hI.setSession(data === null || data === void 0 ? void 0 : (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : (_data$data4$data = _data$data4.data) === null || _data$data4$data === void 0 ? void 0 : _data$data4$data.session));
      onSuccess(data === null || data === void 0 ? void 0 : (_data$data5 = data.data) === null || _data$data5 === void 0 ? void 0 : (_data$data5$data = _data$data5.data) === null || _data$data5$data === void 0 ? void 0 : _data$data5$data.session);
    }

    return function () {
      remove();
    };
  }, [data === null || data === void 0 ? void 0 : (_data$data6 = data.data) === null || _data$data6 === void 0 ? void 0 : (_data$data6$data = _data$data6.data) === null || _data$data6$data === void 0 ? void 0 : (_data$data6$data$sess = _data$data6$data.session) === null || _data$data6$data$sess === void 0 ? void 0 : (_data$data6$data$sess2 = _data$data6$data$sess.user) === null || _data$data6$data$sess2 === void 0 ? void 0 : _data$data6$data$sess2.id]);
  var goBackCallback = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("SignInMobile", goBackCallback, !activeInput);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(back_button_component/* BackButtonBar */.K, {
      onClick: onClose
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (sign_in_mobile_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: t("auth.login-with-mobile")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (sign_in_mobile_module_default()).code_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (sign_in_mobile_module_default()).code,
          children: code
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (sign_in_mobile_module_default()).instruction,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
          children: [t("auth.instructions"), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (sign_in_mobile_module_default()).steps,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (sign_in_mobile_module_default()).step,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (sign_in_mobile_module_default()).number,
              children: "1"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: t("auth.step-1")
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (sign_in_mobile_module_default()).step,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (sign_in_mobile_module_default()).number,
              children: "2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: t("auth.step-2")
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (sign_in_mobile_module_default()).step,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (sign_in_mobile_module_default()).number,
              children: "3"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: t("auth.step-3")
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-navigate-row": true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "data-navigate-item": true
          })
        })]
      })]
    })]
  });
};
// EXTERNAL MODULE: ./app/hooks/keyboard-navigation.hook.ts
var keyboard_navigation_hook = __webpack_require__(36158);
// EXTERNAL MODULE: ./app/hooks/modal-scroll.hook.ts
var modal_scroll_hook = __webpack_require__(76299);
// EXTERNAL MODULE: ./app/components/ui/portal.tsx + 1 modules
var portal = __webpack_require__(64263);
// EXTERNAL MODULE: ./app/components/icons/HeartOutline.tsx
var HeartOutline = __webpack_require__(9761);
;// CONCATENATED MODULE: ./app/components/icons/Bookmark.tsx


function Bookmark_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Bookmark_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Bookmark_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Bookmark_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Bookmark = function Bookmark(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Bookmark_objectSpread(Bookmark_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      clipPath: "url(#a)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M48.875 9.118h-28.75c-3.163 0-5.721 2.588-5.721 5.75l-.029 46L34.5 52.243l20.125 8.625v-46c0-3.162-2.587-5.75-5.75-5.75Z",
        fill: "#000"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "a",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#fff",
          d: "M0 0h69v69H0z"
        })
      })
    })]
  }));
};

var MemoBookmark = /*#__PURE__*/(0,react.memo)(Bookmark);
/* harmony default export */ var icons_Bookmark = (MemoBookmark);
// EXTERNAL MODULE: ./app/components/icons/OfflineOutline.tsx
var OfflineOutline = __webpack_require__(52659);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./app/components/icons/PlaylistAlt.tsx


function PlaylistAlt_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PlaylistAlt_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PlaylistAlt_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PlaylistAlt_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var PlaylistAlt = function PlaylistAlt(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", PlaylistAlt_objectSpread(PlaylistAlt_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 40",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.434 20.419a8.984 8.984 0 100-17.969 8.984 8.984 0 000 17.969zm1.853 14.813V22.72c5.434-.885 9.582-5.6 9.582-11.285 0-.453-.026-.9-.077-1.338l9.552-2.388v16.876a6.734 6.734 0 00-3.404-.92c-3.179 0-6.126 2.249-6.126 5.445 0 3.197 2.947 5.445 6.126 5.445 2.7 0 5.233-1.622 5.935-4.07.122-.204.192-.443.192-.698V5.965a1.361 1.361 0 00-1.692-1.32L22.155 7.45C20.539 3.1 16.349 0 11.436 0 5.119 0 0 5.12 0 11.434c0 6.023 4.656 10.958 10.564 11.403v7.193a6.732 6.732 0 00-3.404-.92c-3.179 0-6.126 2.248-6.126 5.445S3.981 40 7.16 40c2.7 0 5.232-1.622 5.934-4.07.122-.203.193-.442.193-.698zm15.653-8.844c-2.084 0-3.403 1.408-3.403 2.722s1.32 2.723 3.403 2.723c2.084 0 3.403-1.409 3.403-2.723 0-1.314-1.319-2.722-3.403-2.722zM7.16 31.832c-2.084 0-3.403 1.409-3.403 2.723 0 1.314 1.319 2.723 3.403 2.723s3.403-1.409 3.403-2.723c0-1.314-1.32-2.723-3.403-2.723zm5.296-26.32v4.901h4.9v2.042h-4.9v4.9h-2.042v-4.9h-4.9v-2.042h4.9v-4.9h2.042z",
      fill: "#4A88FF"
    })
  }));
};

var MemoPlaylistAlt = /*#__PURE__*/react.memo(PlaylistAlt);
/* harmony default export */ var icons_PlaylistAlt = (MemoPlaylistAlt);
;// CONCATENATED MODULE: ./app/components/auth/auth.component.tsx























var ActiveScreen;

(function (ActiveScreen) {
  ActiveScreen["SIGN_UP"] = "SIGN_UP";
  ActiveScreen["SIGN_IN"] = "SIGN_IN";
  ActiveScreen["SIGN_IN_MOBILE"] = "SIGN_IN_MOBILE";
  ActiveScreen["PASSWORD_RESET"] = "PASSWORD_RESET";
})(ActiveScreen || (ActiveScreen = {}));

var Auth = function Auth(_ref) {
  var onClose = _ref.onClose,
      onSuccess = _ref.onSuccess,
      _ref$parentPopupId = _ref.parentPopupId,
      parentPopupId = _ref$parentPopupId === void 0 ? null : _ref$parentPopupId;
  var t = (0,lang/* useTranslate */.q)();

  var _useState = (0,react.useState)(null),
      activeScreen = _useState[0],
      setActiveScreen = _useState[1];

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      downloadEnabled = _useFeaturesContext.downloadEnabled,
      premiumVersion = _useFeaturesContext.premiumVersion,
      facebookLoginEnabled = _useFeaturesContext.facebookLoginEnabled;

  (0,react.useEffect)(function () {
    window.scrollTo({
      top: 0
    });
  }, [activeScreen]);
  var onCloseCallback = (0,react.useCallback)(function () {
    return setActiveScreen(null);
  }, [setActiveScreen]);

  var renderScreen = function renderScreen() {
    switch (activeScreen) {
      case ActiveScreen.SIGN_IN:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SignIn, {
          onClose: onCloseCallback,
          onSuccess: onSuccess,
          onForgotPassword: function onForgotPassword() {
            return setActiveScreen(ActiveScreen.PASSWORD_RESET);
          }
        });

      case ActiveScreen.SIGN_IN_MOBILE:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SignInMobile, {
          parentPopupId: parentPopupId,
          onClose: onCloseCallback,
          onSuccess: onSuccess
        });

      case ActiveScreen.SIGN_UP:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SignUp, {
          onClose: onCloseCallback,
          onSuccess: onSuccess
        });

      case ActiveScreen.PASSWORD_RESET:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ResetPassword, {
          onClose: onCloseCallback,
          onGoToLogin: function onGoToLogin() {
            return setActiveScreen(ActiveScreen.SIGN_IN);
          }
        });

      default:
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [onClose && /*#__PURE__*/(0,jsx_runtime.jsx)(back_button_component/* BackButtonBar */.K, {
            onClick: onClose
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (auth_module_default()).wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (auth_module_default()).inner,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (auth_module_default()).auth_points,
                children: [premiumVersion && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (auth_module_default()).auth_point,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)((auth_module_default()).auth_icon_wrapper),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_PlaylistAlt, {})
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (auth_module_default()).auth_texts,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                      children: t("auth.export-to-playlist")
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: t("auth.export-to-playlist-desc")
                    })]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (auth_module_default()).auth_point,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)((auth_module_default()).auth_icon_wrapper, (auth_module_default()).heart),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeartOutline/* default */.Z, {})
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (auth_module_default()).auth_texts,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                      children: t("auth.save-your-favorites")
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: t("auth.synchronize-your-account")
                    })]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (auth_module_default()).auth_point,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)((auth_module_default()).auth_icon_wrapper, (auth_module_default()).bookmark),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_Bookmark, {})
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (auth_module_default()).auth_texts,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                      children: t("auth.resume-playback")
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: t("auth.resume-podcasts")
                    })]
                  })]
                }), downloadEnabled && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (auth_module_default()).auth_point,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)((auth_module_default()).auth_icon_wrapper, (auth_module_default()).offline),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(OfflineOutline/* default */.Z, {})
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (auth_module_default()).auth_texts,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                      children: t("auth.offline-podcasts")
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: t("auth.download-podcasts")
                    })]
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                "data-navigate-row": true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* Button */.zx, {
                  className: (auth_module_default()).btn,
                  "data-navigate-item": true,
                  onClick: function onClick() {
                    return setActiveScreen(ActiveScreen.SIGN_UP);
                  },
                  children: t("sign-up")
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Divider, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (auth_module_default()).divider_content,
                  children: t("auth.or")
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                "data-navigate-row": true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* ButtonOutline */.Ig, {
                  className: (auth_module_default()).btn,
                  "data-navigate-item": true,
                  onClick: function onClick() {
                    return setActiveScreen(ActiveScreen.SIGN_IN);
                  },
                  children: t("log-in")
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                "data-navigate-row": true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* ButtonOutline */.Ig, {
                  className: (auth_module_default()).btn,
                  "data-navigate-item": true,
                  onClick: function onClick() {
                    return setActiveScreen(ActiveScreen.SIGN_IN_MOBILE);
                  },
                  children: t("log-in-with-my-mobile")
                })
              })]
            })
          })]
        });
    }
  };

  return renderScreen();
};
var AuthGuardPopup = function AuthGuardPopup(_ref2) {
  var onClose = _ref2.onClose,
      _ref2$onSuccess = _ref2.onSuccess,
      onSuccess = _ref2$onSuccess === void 0 ? function () {} : _ref2$onSuccess,
      moveUnderHeader = _ref2.moveUnderHeader;
  var wrapperRef = (0,keyboard_navigation_hook/* useArrowKeyNavigationOverlay */.Sy)(!moveUnderHeader);
  (0,modal_scroll_hook/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(portal/* Portal */.h, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((auth_module_default()).popup_wrapper, (0,defineProperty/* default */.Z)({}, (auth_module_default()).under_header, moveUnderHeader)),
      ref: wrapperRef,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Auth, {
        onClose: onClose,
        onSuccess: onSuccess
      })
    })
  });
};

/***/ }),

/***/ 56227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ BackButtonBar; },
/* harmony export */   "x": function() { return /* binding */ BackButton; }
/* harmony export */ });
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91289);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var _icons_ArrowBack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40774);
/* harmony import */ var _back_button_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71345);
/* harmony import */ var _back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var BackButtonBar = function BackButtonBar(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      buttonClassName = _ref.buttonClassName;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    "data-navigate-row": true,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper), className),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BackButton, {
      onClick: onClick,
      className: buttonClassName
    })
  });
};
var BackButton = function BackButton(_ref2) {
  var onClick = _ref2.onClick,
      className = _ref2.className;
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_4__/* .useTranslate */ .q)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
    "data-navigate-item": true,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().back), className),
    onClick: onClick,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_icons_ArrowBack__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      children: t("back")
    })]
  });
};

/***/ }),

/***/ 40774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var ArrowBack = function ArrowBack(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M50 27.5H19.575L33.55 13.525 30 10 10 30l20 20 3.525-3.525L19.575 32.5H50v-5z",
      fill: "#fff"
    })
  }));
};

var MemoArrowBack = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ArrowBack);
/* harmony default export */ __webpack_exports__["Z"] = (MemoArrowBack);

/***/ }),

/***/ 9761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var HeartOutline = function HeartOutline(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 81 76",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      filter: "url(#prefix__filter0_d_4529_10429)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("mask", {
        id: "prefix__a",
        fill: "#fff",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M55.151.25c-4.737 0-7.791.578-11.292 2.335a20.126 20.126 0 00-3.642 2.346 20.55 20.55 0 00-3.496-2.239C33.153.883 29.941.25 25.374.25 13.14.25 4.25 10.638 4.25 24.129c0 10.189 5.543 20.03 15.869 29.547 5.42 4.996 12.34 9.94 17.295 12.57l2.836 1.504 2.836-1.505c4.955-2.63 11.875-7.573 17.295-12.569C70.707 44.16 76.25 34.319 76.25 24.13 76.25 10.781 67.276.302 55.151.25z"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        clipRule: "evenodd",
        d: "M55.151.25c-4.737 0-7.791.578-11.292 2.335a20.126 20.126 0 00-3.642 2.346 20.55 20.55 0 00-3.496-2.239C33.153.883 29.941.25 25.374.25 13.14.25 4.25 10.638 4.25 24.129c0 10.189 5.543 20.03 15.869 29.547 5.42 4.996 12.34 9.94 17.295 12.57l2.836 1.504 2.836-1.505c4.955-2.63 11.875-7.573 17.295-12.569C70.707 44.16 76.25 34.319 76.25 24.13 76.25 10.781 67.276.302 55.151.25z",
        stroke: "#fff",
        strokeWidth: 14,
        strokeLinecap: "round",
        shapeRendering: "geometricPrecision",
        mask: "url(#prefix__a)"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "prefix__filter0_d_4529_10429",
        x: 0.25,
        y: 0.25,
        width: 80,
        height: 75.5,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_4529_10429"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_4529_10429",
          result: "shape"
        })]
      })
    })]
  }));
};

var MemoHeartOutline = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(HeartOutline);
/* harmony default export */ __webpack_exports__["Z"] = (MemoHeartOutline);

/***/ }),

/***/ 50147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var app_context_virtual_keyboard_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5451);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _input_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10873);
/* harmony import */ var _input_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_input_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["className", "icon", "dark"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var Input = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function (_ref, inRef) {
  var _clsx3;

  var className = _ref.className,
      icon = _ref.icon,
      dark = _ref.dark,
      inputProps = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle)(inRef, function () {
    return ref.current;
  }, [ref]);

  var _useVirtualKeyboardCo = (0,app_context_virtual_keyboard_context__WEBPACK_IMPORTED_MODULE_1__/* .useVirtualKeyboardContext */ .z)(),
      activeInput = _useVirtualKeyboardCo.activeInput;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().input), (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().dark), dark), className),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("label", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().input__label), (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().error), !!inputProps.error)),
        children: inputProps.label
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", _objectSpread({
        type: "text",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().input__control), (_clsx3 = {}, (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_clsx3, (_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().error), !!inputProps.error), (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_clsx3, (_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().active), activeInput && activeInput === (ref === null || ref === void 0 ? void 0 : ref.current)), _clsx3)),
        ref: ref
      }, inputProps)), icon ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.cloneElement(icon, {
        className: (_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().icon)
      }) : null, inputProps.error && typeof inputProps.error !== "boolean" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
        "data-testid": "".concat(inputProps.name, "-error-message"),
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().message), (_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().message_error)),
        children: inputProps.error
      }), inputProps.message !== null && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
        className: (_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().message),
        children: inputProps.message
      })]
    })
  });
});
Input.displayName = "Input";

/***/ }),

/***/ 47754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","popup_wrapper":"auth_popup_wrapper__d1S4z","under_header":"auth_under_header__AUOGO","wrapper":"auth_wrapper__egh9r","inner":"auth_inner__S71ek","btn":"auth_btn__VJpbW","divider_content":"auth_divider_content__cc1Ml","auth_points":"auth_auth_points__bslin","auth_point":"auth_auth_point__QgmeY","auth_icon_wrapper":"auth_auth_icon_wrapper__2I_16","bookmark":"auth_bookmark___m4_d","offline":"auth_offline___snmF","heart":"auth_heart__mpB5w","playlist":"auth_playlist__qihS8","auth_texts":"auth_auth_texts___tEnI"};

/***/ }),

/***/ 85790:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","container":"reset-password_container__8GMzU","form_group":"reset-password_form_group__Ew37k","success_info":"reset-password_success_info__wYePy","loader_wrapper":"reset-password_loader_wrapper__pB1pz"};

/***/ }),

/***/ 33815:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","container":"sign-in-mobile_container__rCtjg","form_group":"sign-in-mobile_form_group__oBKn5","code_wrapper":"sign-in-mobile_code_wrapper__Ezwaf","code":"sign-in-mobile_code__75dH3","instruction":"sign-in-mobile_instruction__qe_We","steps":"sign-in-mobile_steps__jdSpU","step":"sign-in-mobile_step__7ApfJ","number":"sign-in-mobile_number__A_ija"};

/***/ }),

/***/ 40745:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","forgot_button":"sign-in_forgot_button__l_REk","container":"sign-in_container__oyqmJ","form_group":"sign-in_form_group__H7f4f","loader_wrapper":"sign-in_loader_wrapper__6waFn","facebook_btn_wrapper":"sign-in_facebook_btn_wrapper__kM2wS","facebook_btn":"sign-in_facebook_btn__fwlNo"};

/***/ }),

/***/ 7383:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","back_container":"sign-up_back_container__9lsFH","container":"sign-up_container__7r8wn","form_group":"sign-up_form_group__9skyI","accept_terms":"sign-up_accept_terms__PWT2w","facebook_btn_wrapper":"sign-up_facebook_btn_wrapper__tFM_T","facebook_btn":"sign-up_facebook_btn__PUQsJ"};

/***/ }),

/***/ 71345:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","back":"back-button_back__KRknK","forgot_button":"back-button_forgot_button__Jmz7Z","wrapper":"back-button_wrapper__cmCKR","absolute":"back-button_absolute__HllSl"};

/***/ }),

/***/ 48335:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__z3cUf"};

/***/ }),

/***/ 10873:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","input__control":"input_input__control__OJaMy","input":"input_input__zebje","input__label":"input_input__label__rRcZy","error":"input_error__acX9x","active":"input_active__R9xQT","icon":"input_icon__4jZSA","message":"input_message__YpDdi","message_error":"input_message_error__M_sZ5"};

/***/ })

}]);